import { ArrowRight, Check } from 'lucide-react';
import { NumberTicker } from '@/components/ui/number-ticker';
import { Reveal } from '@/components/ui/reveal';
import { CtaButton } from './cta-button';

const INCLUSIONS = [
  'Encroachment (Kabzaa) alerts',
  'Photos and videos of the property',
  'Waste dumping alerts',
  'Drain status',
  'Vegetation overgrowth alerts',
  'Waterlogging alerts',
];

/**
 * Split Studio module · text-left / proof-right.
 * The price is set as a figure in open space rather than a bordered plan
 * card — no frame, no rotated ribbon, no dashed rule.
 */
export function Pricing() {
  return (
    <section
      id="pricing"
      className="mx-auto max-w-6xl scroll-mt-8 px-4 py-14 sm:px-6 sm:py-20 md:py-28"
    >
      <div className="grid gap-10 sm:gap-12 lg:grid-cols-[minmax(0,4fr)_minmax(0,7fr)] lg:gap-20">
        <Reveal className="lg:sticky lg:top-12 lg:self-start">
          <h2 className="font-display text-3xl font-medium leading-tight tracking-tight text-foreground md:text-4xl">
            Pricing
          </h2>
          <p className="mt-5 max-w-sm leading-relaxed text-foreground/65">
            Managing multiple properties or NRI clients?{' '}
            <a
              href="/contact-us"
              className="text-ring underline-offset-4 hover:underline focus-visible:rounded-sm focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring"
            >
              Talk to us about agent pricing →
            </a>
          </p>
        </Reveal>

        <Reveal delay={0.08}>
          <p className="font-display text-sm text-foreground/65">Starting at</p>
          <p className="mt-2 font-display text-foreground">
            <span className="align-top text-3xl">₹</span>
            <span className="text-6xl font-medium sm:text-7xl">
              <NumberTicker value={2000} />
            </span>
            <span className="ml-2 text-xl text-foreground/65">/ visit</span>
          </p>
          <p className="mt-3 text-foreground/65">
            Each inspection includes photos and video of your land.
          </p>

          <ul className="mt-9 grid gap-x-10 border-t border-line-strong sm:grid-cols-2">
            {INCLUSIONS.map((item) => (
              <li
                key={item}
                className="flex items-center gap-3 border-b border-border py-3 text-foreground/80"
              >
                <Check className="size-4 shrink-0 text-sidebar-primary" aria-hidden />
                {item}
              </li>
            ))}
          </ul>

          <div className="mt-9">
            <CtaButton location="pricing" variant="clay" depth="3d" className="w-full sm:w-auto">
              Start Monitoring
              <ArrowRight className="size-4" />
            </CtaButton>
            <p className="mt-3 text-sm text-foreground/65">Cancel anytime</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
